var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupingBy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.51812 13.6321C1.32335 13.8246 1.00998 13.8246 0.815211 13.6321L0.359873 13.1821C0.161813 12.9864 0.161813 12.6666 0.359873 12.4708L4.01812 8.85562C4.11317 8.76169 4.16667 8.63362 4.16667 8.49998V4.36766C4.16667 3.92364 3.63104 3.69992 3.31521 4.01203L2.37229 4.94386C2.17752 5.13634 1.86415 5.13634 1.66938 4.94386L1.19321 4.47329C0.995147 4.27756 0.995147 3.95774 1.19321 3.76201L4.64854 0.34732C4.84332 0.154839 5.15668 0.154839 5.35145 0.34732L8.82763 3.7826C9.02569 3.97833 9.02569 4.29814 8.82763 4.49387L8.35145 4.96444C8.15668 5.15693 7.84332 5.15693 7.64854 4.96444L6.68479 4.01203C6.36896 3.69992 5.83333 3.92364 5.83333 4.36767V9.15881C5.83333 9.29244 5.77984 9.42051 5.68479 9.51444L1.51812 13.6321ZM9.18341 13.654C8.98918 13.846 8.67688 13.8466 8.4819 13.6554L6.52935 11.7409C6.32998 11.5454 6.32935 11.2245 6.52795 11.0283L7.00133 10.5605C7.19665 10.3674 7.51107 10.368 7.70563 10.5618L9.64293 12.4914C9.83967 12.6874 9.83905 13.0061 9.64153 13.2013L9.18341 13.654Z",
    fill: "#current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupingBy);
export default __webpack_public_path__ + "static/media/GroupingBy.ef2cecca18bafa5b6c7172c8a43d6a8f.svg";
export { ForwardRef as ReactComponent };